import flagNotFound from "../assets/flags/xx.svg";

export interface MarketWithName {
	code: string;
	name: string;
}

const flagImages = import.meta.glob("../assets/flags/*.svg", {
	eager: true,
	import: "default",
}) as Record<string, string>;

export const getImage = (market: string | null) => {
	const code = market?.toLowerCase();

	if (!code) {
		return flagNotFound;
	}

	return flagImages[`../assets/flags/${code}.svg`] || flagNotFound;
};
